export default __webpack_public_path__ + "images/ZX.27b6cba.png";